import { render } from "./Nephrology.vue?vue&type=template&id=71f63173&scoped=true"
import script from "./Nephrology.vue?vue&type=script&lang=ts"
export * from "./Nephrology.vue?vue&type=script&lang=ts"

import "./Nephrology.vue?vue&type=style&index=0&id=71f63173&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71f63173"

export default script